var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _rect, _path2, _polygon6, _path3, _polygon7, _path4, _path5, _path6, _path7, _rect2, _polygon8, _path8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0428\\u0430\\u0440_1",
    "data-name": "\\u0428\\u0430\\u0440 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 77.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13);}.cls-2{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-2);}.cls-3{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-3);}.cls-4{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-4);}.cls-5{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-5);}.cls-6{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-6);}.cls-7{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-7);}.cls-8{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-8);}.cls-9{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-9);}.cls-10{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-10);}.cls-11{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-11);}.cls-12{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-12);}.cls-13{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-13);}.cls-14{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-14);}.cls-15{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-15);}.cls-16{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-16);}.cls-17{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-17);}.cls-18{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-18);}.cls-19{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-19);}.cls-20{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-20);}.cls-21{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_13-21);}.cls-22{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13",
    y1: 48.92,
    x2: 48.82,
    y2: 48.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#234c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51cde2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-2",
    x1: 8.81,
    y1: 58.04,
    x2: 48.67,
    y2: 58.04,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-3",
    x1: 19.29,
    y1: 66.76,
    x2: 49.72,
    y2: 66.76,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-4",
    y1: 39.78,
    x2: 41.1,
    y2: 39.78,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-5",
    y1: 30.98,
    x2: 29.35,
    y2: 30.98,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-6",
    x1: 14.36,
    y1: 17.34,
    x2: 65.1,
    y2: 68.08,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-7",
    x1: 48.53,
    y1: 7.54,
    x2: 48.53,
    y2: 14.64,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-8",
    x1: 48.53,
    y1: 19.53,
    x2: 48.53,
    y2: 26.63,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-9",
    x1: 48.53,
    y1: 31.52,
    x2: 48.53,
    y2: 38.62,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-10",
    x1: 48.53,
    y1: 43.51,
    x2: 48.53,
    y2: 50.61,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-11",
    x1: 48.53,
    y1: 55.51,
    x2: 48.53,
    y2: 62.6,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-12",
    x1: 27.81,
    y1: 19.53,
    x2: 27.81,
    y2: 26.63,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-13",
    x1: 69.25,
    y1: 19.53,
    x2: 69.25,
    y2: 26.63,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-14",
    x1: 69.25,
    y1: 31.52,
    x2: 69.25,
    y2: 38.62,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-15",
    x1: 69.25,
    y1: 43.51,
    x2: 69.25,
    y2: 50.61,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-16",
    x1: 58.89,
    y1: 14.05,
    x2: 58.89,
    y2: 21.15,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-17",
    x1: 58.89,
    y1: 26.05,
    x2: 58.89,
    y2: 33.14,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-18",
    x1: 58.89,
    y1: 38.04,
    x2: 58.89,
    y2: 45.14,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-19",
    x1: 58.89,
    y1: 50.03,
    x2: 58.89,
    y2: 57.13,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-20",
    x1: 38.17,
    y1: 14.05,
    x2: 38.17,
    y2: 21.15,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13-21",
    x1: 38.17,
    y1: 26.05,
    x2: 38.17,
    y2: 33.14,
    xlinkHref: "#\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_13"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.82 35.58 0 63.28 0 61.94 48.24 34.57 48.82 35.58"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "48.67 47.57 9.98 69.52 8.81 68.85 48.09 46.56 48.67 47.57"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "49.72 58.96 20.45 75.57 19.29 74.89 49.15 57.95 49.72 58.96"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.1 28.63 0 51.95 0 50.61 40.52 27.61 41.1 28.63"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "29.35 23.08 0.13 39.66 0 39.73 0 38.4 28.5 22.22 29.35 23.08"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M43.14,72.56,14,55.77V22.17L43.13,5.38V0L9.39,19.48v39L43.14,77.94l29.1-16.8V55.77Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 48.53,
    cy: 11.09,
    r: 3.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 48.53,
    cy: 23.08,
    r: 3.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 48.53,
    cy: 35.07,
    r: 3.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 48.53,
    cy: 47.06,
    r: 3.55
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 48.53,
    cy: 59.06,
    r: 3.55
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 27.81,
    cy: 23.08,
    r: 3.55
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 69.25,
    cy: 23.08,
    r: 3.55
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 69.25,
    cy: 35.07,
    r: 3.55
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 69.25,
    cy: 47.06,
    r: 3.55
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 58.89,
    cy: 17.6,
    r: 3.55
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 58.89,
    cy: 29.6,
    r: 3.55
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 58.89,
    cy: 41.59,
    r: 3.55
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 58.89,
    cy: 53.58,
    r: 3.55
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 38.17,
    cy: 17.6,
    r: 3.55
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 38.17,
    cy: 29.6,
    r: 3.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 84.39,
    y: 15.6,
    width: 0.92,
    height: 46.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M110.18,28.89A14.47,14.47,0,0,1,115,25.74a17.17,17.17,0,0,1,11.82-.1,13.34,13.34,0,0,1,4.9,3.28l2.43-2.43a15,15,0,0,0-5.84-3.95A20.69,20.69,0,0,0,121,21.23a20.33,20.33,0,0,0-7.53,1.37,18,18,0,0,0-6,3.84,17.58,17.58,0,0,0-4,5.83,19.63,19.63,0,0,0,0,14.66,17.65,17.65,0,0,0,9.94,9.68,21.4,21.4,0,0,0,15,0,15.1,15.1,0,0,0,5.84-4l-2.43-2.43a13.68,13.68,0,0,1-4.9,3.31A16.86,16.86,0,0,1,115,53.46a14.31,14.31,0,0,1-4.85-3.15A14.82,14.82,0,0,1,107,45.56a15.89,15.89,0,0,1,0-11.92A14.82,14.82,0,0,1,110.18,28.89Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "164.57 21.54 152.19 41.8 139.8 21.54 135.72 21.54 150.18 45.19 150.18 57.66 153.94 57.66 153.94 45.19 168.39 21.54 164.57 21.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M198.45,39.68a11.92,11.92,0,0,0-2.19-.67c.16-.06.33-.11.49-.18a8.2,8.2,0,0,0,5.08-8A8,8,0,0,0,198.51,24c-2.22-1.61-5.35-2.42-9.37-2.42H173.55V57.66h16.62q6.81,0,10.19-2.52A8.37,8.37,0,0,0,203.74,48a9.12,9.12,0,0,0-1.39-5.18A8.48,8.48,0,0,0,198.45,39.68Zm-9.57-15a12,12,0,0,1,6.74,1.62,5.56,5.56,0,0,1,2.4,4.93,5.55,5.55,0,0,1-2.4,4.9,11.72,11.72,0,0,1-6.74,1.66H177.37V24.69Zm8.52,28.2c-1.69,1.08-4.12,1.63-7.28,1.63H177.37V40.94h12.75c3.16,0,5.59.55,7.28,1.63a5.65,5.65,0,0,1,2.52,5.13A5.71,5.71,0,0,1,197.4,52.89Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "216.28 40.94 234.97 40.94 234.97 37.69 216.28 37.69 216.28 24.84 237.24 24.84 237.24 21.54 212.47 21.54 212.47 57.66 238.01 57.66 238.01 54.36 216.28 54.36 216.28 40.94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.41,44.74a11.28,11.28,0,0,0,5.08-4.24,11.84,11.84,0,0,0,1.78-6.58,12,12,0,0,0-1.78-6.68A11.33,11.33,0,0,0,268.41,23a19.34,19.34,0,0,0-7.9-1.47H247V57.66h3.82V46.21h9.7a24.5,24.5,0,0,0,2.91-.17l8.24,11.62h4.18L267,45.27C267.49,45.11,268,44.94,268.41,44.74Zm-8-1.78h-9.6V24.84h9.6c3.61,0,6.36.79,8.23,2.38a8.26,8.26,0,0,1,2.81,6.7,8.21,8.21,0,0,1-2.81,6.66C266.77,42.17,264,43,260.41,43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M302.78,28.89a14.47,14.47,0,0,1,4.85-3.15,17.17,17.17,0,0,1,11.82-.1,13.34,13.34,0,0,1,4.9,3.28l2.43-2.43A15,15,0,0,0,321,22.54a20.77,20.77,0,0,0-7.38-1.31A20.38,20.38,0,0,0,306,22.6a18,18,0,0,0-6,3.84,17.58,17.58,0,0,0-4,5.83,19.63,19.63,0,0,0,0,14.66A17.65,17.65,0,0,0,306,56.61a21.43,21.43,0,0,0,15,0,15.14,15.14,0,0,0,5.83-4l-2.43-2.43a13.68,13.68,0,0,1-4.9,3.31,16.86,16.86,0,0,1-11.82-.08,14.31,14.31,0,0,1-4.85-3.15,14.82,14.82,0,0,1-3.23-4.75,15.89,15.89,0,0,1,0-11.92A14.82,14.82,0,0,1,302.78,28.89Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M344.74,21.54,328.22,57.66h4L336.52,48h20.16L361,57.66h4L348.51,21.54ZM337.9,44.92l8.7-19.43,8.69,19.43Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M392.42,23a19.29,19.29,0,0,0-7.89-1.47H371V57.66h3.82V46.26h9.7a19,19,0,0,0,7.89-1.5,11.48,11.48,0,0,0,5.09-4.26,11.92,11.92,0,0,0,1.78-6.58,12.13,12.13,0,0,0-1.78-6.68A11.36,11.36,0,0,0,392.42,23Zm.24,17.55c-1.88,1.56-4.62,2.34-8.24,2.34h-9.59V24.84h9.59c3.62,0,6.36.79,8.24,2.38a8.29,8.29,0,0,1,2.81,6.7A8.19,8.19,0,0,1,392.66,40.56Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 407.54,
    y: 21.54,
    width: 3.82,
    height: 36.13
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "446.66 21.54 417.45 21.54 417.45 24.84 430.15 24.84 430.15 57.66 433.97 57.66 433.97 24.84 446.66 24.84 446.66 21.54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M461.68,21.54,445.17,57.66h4L453.46,48h20.16l4.32,9.65h4L465.45,21.54Zm-6.84,23.38,8.7-19.43,8.69,19.43Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "491.77 54.36 491.77 21.54 487.95 21.54 487.95 57.66 512 57.66 512 54.36 491.77 54.36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/cyber.11ae55be80bcdf19e01cbe3179357b46.svg";
export { ForwardRef as ReactComponent };